import firebase from "firebase/app";
import {suggestionReads} from "./lib/readCache.mjs";
import {lazyFunctions} from "./lib/lazyFunctions.mjs";
import {withDemoCollections, demoEnabled} from "./lib/demoMode.mjs";
import "firebase/firestore";
import "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD48BhiZ53QxS8n6SYBo1mZ_F6fGrMIIrA",
  authDomain: "wws-intl.firebaseapp.com",
  databaseURL: "https://wws-intl.firebaseio.com",
  projectId: "wws-intl",
  storageBucket: "wws-intl.appspot.com",
  messagingSenderId: "1045599078576",
  appId: "1:1045599078576:web:142208751c865d0c785375",
  measurementId: "G-T9P8LRLF31"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let demoUser = null;
export const setDemoUser = user => { demoUser = user; suggestionReads.clear(); };
export const isDemoMode = () => demoEnabled(demoUser);
const rawFirestore = firebase.firestore();
const demoReadErrorListeners = new Set();
export const onDemoReadError = listener => {
  demoReadErrorListeners.add(listener);
  return () => demoReadErrorListeners.delete(listener);
};
export const firestore = withDemoCollections(rawFirestore, isDemoMode, error => {
  if (isDemoMode()) {
    console.error("Demo/production query failed", error);
    demoReadErrorListeners.forEach(listener => listener(error));
  }
});
export const auth = firebase.auth();
// Callable clients already return promises. Load their SDK on the first call,
// rather than downloading it for every landing/login visit.
export const functions = lazyFunctions(() => import("firebase/functions").then(() => firebase.functions()));
export const signOut = () => auth.signOut();

export default firebase;
